import React from "react";

const TONES = {
  created:   { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-300", dot: "bg-emerald-500", label: "Creada" },
  pending:   { bg: "bg-amber-50",   text: "text-amber-700",   border: "border-amber-300",   dot: "bg-amber-500",   label: "Pendiente" },
  failed:    { bg: "bg-red-50",     text: "text-red-700",     border: "border-red-300",     dot: "bg-red-500",     label: "Fallida" },
  cancelled: { bg: "bg-gray-100",   text: "text-gray-700",    border: "border-gray-300",    dot: "bg-gray-500",    label: "Cancelada" },
};

export default function StatusBadge({ status }) {
  const tone = TONES[status] || TONES.pending;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full border ${tone.bg} ${tone.text} ${tone.border} text-xs font-semibold tracking-wide`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${tone.dot}`} />
      {tone.label}
    </span>
  );
}
